/**
 * Shared React Query `meta.invalidates` tag sets for mutations.
 * Pair with matching `meta.tags` on queries so the shared MutationCache can refetch.
 */

/** Mark stale without refetching so patched property-table pages keep stable row order. */
export const ARCHIVE_STALE_ONLY_TAGS = ['getProperties', 'getPropertyTableUnitsList'] as const;
export const DEFAULT_ARCHIVE_INVALIDATES = [
  'getProperties',
  'getMultiplexUnits',
  'getPropertyTableUnitsList',
  'zramOptions',
] as const;

export const HAS_SEEN_FEATURE_TOUR_TAG = 'hasSeenFeatureTour' as const;
